export function setIsSavingTreatmentAbroad(state, payload) {
  state.isSavingTreatmentAbroad = payload;
}
